<script lang="ts">
  type AspectRatio = '1:1' | '4:3' | '3:4' | '16:9' | '9:16';

  export let og: {
    title: string;
    description: string;
    image: {
      url: string;
      alt?: string;
      aspectRatio?: AspectRatio;
    };
  };
  // Accept domain to match usage in +layout.svelte (not currently used here)
  export let domain = undefined;

  // Compute meta width/height based on aspect ratio, keeping the longest edge at 1200
  const parseAspect = (ar?: string): [number, number] => {
    if (!ar) return [1, 1];
    const parts = ar.split(':').map(n => parseInt(n, 10));
    return parts.length === 2 && parts.every(Number.isFinite) ? [parts[0], parts[1]] : [1, 1];
  };

  let metaWidth = 1200;
  let metaHeight = 1200;
  $: if (og?.image) {
    const [aw, ah] = parseAspect(og.image.aspectRatio);
    if (aw >= ah) {
      metaWidth = 1200;
      metaHeight = Math.round((1200 * ah) / aw);
    } else {
      metaHeight = 1200;
      metaWidth = Math.round((1200 * aw) / ah);
    }
  }
</script>

<svelte:head>
  {#if og}
    <title>{og.title}</title>
    <meta name="description" content={og.description} />
    <meta property="og:type" content="website" />
    <meta property="og:title" content={og.title} />
    <meta property="og:description" content={og.description} />
    <meta property="og:image" content={og.image.url} />
    <meta property="og:image:width" content={String(metaWidth)} />
    <meta property="og:image:height" content={String(metaHeight)} />
    <meta property="og:image:alt" content={og.image.alt || og.title} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={og.title} />
    <meta name="twitter:description" content={og.description} />
    <meta name="twitter:image" content={og.image.url} />
    <meta name="robots" content="max-image-preview:large" />
    <!-- Favicons -->
    <link rel="icon" href="/favicon.svg" type="image/svg+xml" />
    <link rel="icon" href="/favicon.ico" sizes="any" />
    <link rel="icon" href="/favicon-96x96.png" type="image/png" sizes="96x96" />
    <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
    <!-- Web App Manifest -->
    <link rel="manifest" href="/manifest.json" />
  {/if}
</svelte:head>